export enum PRODUCT_SERVICE_ENDPOINTS {
  ENHANCED_PRODUCT_COMMON_PATH = 'core/showroom/buyingSessionGroup',
  GET_FILTER_ATTRIBUTES_OPTIONS = 'collection/listFilterAttributes'
}

export const MANDATORY_ATTRIBUTE_FIELDS = [
  'id',
  'isCore',
  'isFavorite',
  'isRecommended',
  'original-externalImages',
  'original-defaultImage-id',
  'original-active'
]

export const MANDATORY_LOOKBOOK_ATTRIBUTE_FIELDS = [
  ...MANDATORY_ATTRIBUTE_FIELDS,
  'original-looks-defaultImage-id',
  'original-looks'
]

export const MANDATORY_ORDER_ATTRIBUTE_FIELDS = [
  'id',
  'isCore',
  'isFavorite',
  'isRecommended',
  'original-externalImages',
  'original-defaultImage-id',
  'original-active',
  'excludedClients-id',
  'channels',
  'allClustersExcluded',
  'clientOrderProductId'
]

export const SKIP_GROUP_IDENTIFIER = '_SKIP_LEVEL'

export const ENHANCED_VIEW_ROUTES = {
  collection: 'enhanced-client-collection',
  wishlist: 'enhanced-client-wishlist',
  orderCollection: 'enhanced-order',
  basketAndOrders: 'enhanced-basketAndOrders',
  lookbook: 'enhanced-lookbook'
}
